module.exports = __webpack_public_path__ + "img/popularize10.8d8325a2.png";